import PersonalProfile from "Admin/Pages/PersonalProfile/PersonalProfile";
import UnitListManagement from "Admin/Pages/UnitListManagement/UnitListManagement";
import FacultyProfileList from "Admin/Pages/FacultyProfileList/FacultyProfileList";
import UnitDetail from "Admin/Pages/UnitDetail/UnitDetail";
export const _routes = [
  {
    path: "/my-profile/*",
    exact: true,
    component: PersonalProfile,
    name: "My profile",
    permissions: [],
    level: 1,
  },
  {
    path: "/units",
    exact: true,
    component: UnitListManagement,
    name: "Management unit",
    permissions: [],
    level: 1,
  },
  {
    path: "/units/:id/*",
    exact: true,
    component: UnitDetail,
    name: "Unit Detail",
    permissions: [],
    level: 2,
  },
  {
    path: "/profiles",
    exact: true,
    component: FacultyProfileList,
    name: "Faculty profile list",
    permissions: [],
    level: 1,
  },
];
